// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fsRjQsePCOqWh1LwmMMg {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

.NL5NS3KnXJDTb277HA8Q {
    height: 42px;
    padding: 4px;
    box-sizing: border-box;
    border-radius: 5px;
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
    outline: none
}

.NL5NS3KnXJDTb277HA8Q:hover, .NL5NS3KnXJDTb277HA8Q:focus {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    cursor: pointer;
}

.NL5NS3KnXJDTb277HA8Q:focus {
    box-shadow: 0 0 6px #b1bdff;
}

.NL5NS3KnXJDTb277HA8Q:disabled {
    background-color: #F1F1F4;
    border-color: #CCCCCC;
    color: rgb(84, 84, 84);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,0DAA8B;IAC9B;AACJ;;AAEA;IACI,0DAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":["@value colors: \"../library/style/colors.css\";\n@value color-gray-light, color-purple from colors;\n\n\n.dropdown {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n}\n\n.select {\n    height: 42px;\n    padding: 4px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    border-color: color-gray-light;\n    outline: none\n}\n\n.select:hover, .select:focus {\n    border-color: color-purple;\n    cursor: pointer;\n}\n\n.select:focus {\n    box-shadow: 0 0 6px #b1bdff;\n}\n\n.select:disabled {\n    background-color: #F1F1F4;\n    border-color: #CCCCCC;\n    color: rgb(84, 84, 84);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../library/style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"dropdown": `fsRjQsePCOqWh1LwmMMg`,
	"select": `NL5NS3KnXJDTb277HA8Q`
};
export default ___CSS_LOADER_EXPORT___;
